import CocomaterialImage from './CocomaterialImage.vue'

export default CocomaterialImage
